import { FIRST_PAGE } from "constants/CommonConstants";

export const infiniteQueryConfig = {
  getNextPageParam: (lastPage) => {
    if (lastPage.data.next) {
      return lastPage.data.current + 1;
    }
    return undefined;
  },
  initialPageParam: FIRST_PAGE,
};

